<template>
  <div>
    <navbar></navbar>
    <router-view></router-view>
  </div>
</template>
<script>
import navbar from "./navbar";
export default {
  components:{
    navbar
  },

  // directives
  // filters

  props: {
    //
  },

  data: () => ({
    //
  }),

  computed: {
    //
  },

  watch: {
    //
  },

  mounted () {
    //
  },

  methods: {
    //
  }

}
</script>

<style></style>
